import React from 'react';

export default function Diary() {
	return <div>다이어리</div>;
}
